import { RoomSettings } from '../../models'

export const DEFAULT_ROOM_SETTINGS: RoomSettings = {
  capacity: 1,
  default: false,
  note: '',
  onlineBookable: false,
  useAutoCalculateRoomCapacity: false,
}
